<app-form-row
  label="admin.global.addressLine1"
  [labelFor]="line1InputId"
  [required]="line1Required"
  [layout]="layout"
>
  <app-input-text
    #line1Cmp
    [bare]="true"
    [inputId]="line1InputId"
    inputType="text"
    [control]="line1Control"
    [placeholder]="'admin.global.addressLine1' | translate"
    [autocomplete]="line1Control?.value ? 'none' : 'address-line1'"
    [maxLength]="128"
  ></app-input-text>
</app-form-row>

<app-form-row
  label="admin.global.addressLine2"
  [labelFor]="id('addressLine2')"
  [layout]="layout"
>
  <app-input-text
    [bare]="true"
    [inputId]="id('addressLine2')"
    inputType="text"
    [control]="line2Control"
    [placeholder]="'admin.global.addressLine2' | translate"
    autocomplete="address-line2"
    [maxLength]="128"
  ></app-input-text>
</app-form-row>

<app-form-row
  label="admin.global.postCode"
  [labelFor]="id('postCode')"
  [required]="postCodeRequired"
  [layout]="layout"
>
  <app-input-text
    [bare]="true"
    [inputId]="id('postCode')"
    inputType="text"
    [control]="postCodeControl"
    [placeholder]="'admin.global.postCode' | translate"
    autocomplete="postal-code"
    [maxLength]="16"
    [customValidationMessages]="{ pattern: 'admin.global.postCodePattern' }"
  ></app-input-text>
</app-form-row>

<app-form-row
  label="admin.store.region.label"
  [labelFor]="id('region')"
  [layout]="layout"
>
  <app-input-text
    [bare]="true"
    [inputId]="id('region')"
    inputType="text"
    [control]="regionControl"
    [placeholder]="'admin.store.region.label' | translate"
    autocomplete="address-level1"
    [maxLength]="64"
  ></app-input-text>
</app-form-row>

<app-form-row
  label="admin.store.city.label"
  [labelFor]="id('city')"
  [required]="cityRequired"
  [layout]="layout"
>
  <app-input-text
    [bare]="true"
    [inputId]="id('city')"
    inputType="text"
    [control]="cityControl"
    [placeholder]="'admin.store.city.label' | translate"
    autocomplete="address-level2"
    [maxLength]="64"
  ></app-input-text>
</app-form-row>
